<template>
    <div class='card'>
        <BioDataTable ref="sampleStorageTable"
                      :needSelfAdption="true"
                      url="/user/sample"
                      :paramsBody="{micAccountName: micAccountName}"
                      :columns="columns"
                      :is-dto="true"
                      operate-column-style='width: 77px;'
                      :showColumnParams="{module: 'SampleStorage', tableName: 'table1'}"
                      :rows='50'
        />
    </div>
</template>

<script>

import BioDataTable from '@/components/BioDataTable/BioDataTable.vue';

export default {
    components: { BioDataTable },
    data() {
        return {
            micAccountName: localStorage.getItem('micAccountName'),
            columns:[
                {field:"projectId",header:"Project ID",style:"width:180px",isEdit: false,isFilter:true},
                {field:"projectName",header:"Project Name",style:"width:180px",isEdit: false,isFilter:true},
                {field:"clientSampleId",header:"Client Sample ID",style:"width:180px",isEdit: false,isFilter:true},
				{field:"status",header:"Status",style:"width:180px",isEdit: false,isFilter:true},
                {field:"patientId",header:"Patient / Subject ID",style:"width:180px",isEdit: false,isFilter:true},
                {field:"predicineSampleId",header:"Predicine Sample ID",style:"width:180px",isEdit: false,isFilter:true},
                {field:"sampleBarcode",header:"Sample Barcode",style:"width:180px",isEdit: false,isFilter:true},
                {field:"dateReceived",header:"Date Received",style:"width:180px",isEdit: false,isFilter:true},
                {field:"externalTrialVisit",header:"External Trial Visit",style:"width:180px",isEdit: false,isFilter:true},
                //增加字段  Trial Visit
                {field:"externalTrialVisit",header:"Trial Visit",style:"width:180px",isEdit: false,isFilter:true},
                {field:"accessionQuantity",header:"Accession Quantity",style:"width:180px",isEdit: false,isFilter:true},
               /* {field:"accessionUnit",header:"Quantity Unit",style:"width:180px",isEdit: false,isFilter:true},*/
               /* {field:"currentQuantity",header:"Current Quantity",style:"width:180px",isEdit: false,isFilter:true},
                {field:"currentUnit",header:"Quantity Unit",style:"width:180px",isEdit: false,isFilter:true},*/
                //{field:"tumorFraction",header:"Tumor Fraction",style:"width:180px",isEdit: false,isFilter:true},
                // {field:"initialStorageLocation",header:"Initial Storage Location",style:"width:180px",isEdit: false,isFilter:true},
                
            ],
        };
    },
    created() {
    },
    mounted() {
    },
    methods: {
        sliceRendering(dataName, dom, data) {
            this[dataName] = [];
            let total = data.length;
            let once = 30;
            let index = 0;
            var that = this;
            that[dataName].push(...data.slice(index * once, (index + 1) * once));
            // console.log(...data.slice(index*once,(index+1)*once),'...data.slice(index*once,(index+1)*once)')
            index++;

            that.initTableTd();
            dom.scroll((e) => {
                var currentScroll = e.target.scrollTop + e.target.clientHeight;
                var endScroll = e.target.scrollHeight;
                that.initTableTd();
                if (currentScroll >= endScroll - 10) {
                    that[dataName].push(...data.slice(index * once, (index + 1) * once));
                    index++;
                }
            });
        },

        formatDate(value) {
            return value.toLocaleDateString('en-US', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        handleBeforeUnload() {
        },
        handleIconClick() {
            this.aiChat = true;
        },
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    updated() {
        // console.log('App.vue finish re-render')
    },

};
</script>

<style lang='scss' scoped>
:deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.col_bbb {
    color: #bbb;
}

.widget-overview-box .overview-text {
    margin-top: 4px;
}

.widget-timeline .p-timeline .p-timeline-event-content .type {
    // padding: 0 4px;
    border-radius: 4px;
    color: #868C9B;
    margin-right: 8px;
}

.sameHeight {
    height: 555px !important;
    overflow: auto;
}

.widget-performance .content ul li .person-info {
    width: 100%;

    .amount {
        font-size: 14px;
    }

    .name {
        margin-top: 4px;

        span {
            float: right;
        }
    }
}

.widget-target {
    :deep(.p-timeline.p-timeline-vertical .p-timeline-event-opposite) {
        flex: 0;
        padding: 0;
    }

    :deep(.p-timeline.p-timeline-vertical .p-timeline-event-connector) {
        width: 0px
    }

    .p-timeline-event-content .type {
        margin-top: 4px;
        font-size: 12px;
        color: #868C9B;

        span {
            float: right;
        }
    }
}

.floating-icon {
    width: 50px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
    border: 1px solid #a0d2fa;
    border-radius: 50%;
    z-index: 999;
}

.title {
    font-weight: bold;
}
</style>
